import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Zap, Clock, RefreshCw, User, XCircle, Archive } from 'lucide-react';
import { Button } from '@/components/ui/button';
import api from '@/services/api';

// Homepage DJ call-to-action. Renders only for logged-in users, with state driven
// by GET /api/users/me/dj-application (404 => no application yet).
// Chunk 2 CTA states. Pending/rejected/removed/archived route to the dedicated
// /dj-status page; approved routes to the public profile; none routes to apply.
const STATES = {
  none:     { icon: Zap,      title: 'Want to join as a DJ?',  sub: 'Apply to get listed in the public DJ directory.', cta: 'Apply as a DJ',              to: '/dj-application' },
  pending:  { icon: Clock,    title: 'DJ Application Submitted', sub: 'Your application is under review.',              cta: 'View DJ Application Status', to: '/dj-status' },
  rejected: { icon: RefreshCw, title: 'DJ Status',             sub: 'Your DJ profile is no longer active.',            cta: 'View DJ Status',             to: '/dj-status' },
  approved: { icon: User,     title: 'View My DJ Profile',     sub: 'Your DJ profile is live.',                        cta: 'View My DJ Profile',         to: '/dj-status' },
  removed:  { icon: XCircle,  title: 'DJ Status',              sub: 'Your DJ profile is no longer active.',            cta: 'View DJ Status',             to: '/dj-status' },
  archived: { icon: Archive,  title: 'DJ Status',              sub: 'Your DJ profile is no longer active.',            cta: 'View DJ Status',             to: '/dj-status' },
};

export function DJCallToAction() {
  const [state, setState] = useState(null);   // application status key or 'none'
  const [profileUrl, setProfileUrl] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!api.isAuthenticated()) { setReady(true); return; }
    api.get('/users/me/dj-application')
      .then((app) => { setState(app?.status || 'none'); setProfileUrl(app?.public_profile_url || null); })
      .catch(() => setState('none'))   // 404 => no application
      .finally(() => setReady(true));
  }, []);

  if (!ready || !api.isAuthenticated() || !state) return null;
  const cfg = STATES[state] || STATES.none;
  const Icon = cfg.icon;
  const to = state === 'approved' && profileUrl ? profileUrl : cfg.to;

  return (
    <section className="py-6 border-b border-border/50">
      <div className="container mx-auto px-4">
        <div className="glass-card rounded-xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary/20"><Icon className="w-5 h-5 text-primary" /></div>
            <div>
              <p className="font-display font-bold">{cfg.title}</p>
              <p className="text-sm text-muted-foreground">{cfg.sub}</p>
            </div>
          </div>
          <Link to={to}><Button variant="premium" size="sm">{cfg.cta}</Button></Link>
        </div>
      </div>
    </section>
  );
}

export default DJCallToAction;
